import { styled, Typography } from "@material-ui/core";
import { PlaceOutlined as VenueIcon } from "@material-ui/icons";
import FullPageCircularProgress from "components/full-page-circular-progress";
import { brand } from "../../theme";

export const CircularProgress = FullPageCircularProgress;

export const Container = styled("div")({
    background: brand.surface,
    minHeight: "100%",
});

export const HeroCard = styled(({ venue, className }) => (
    <div className={className}>
        <div className="circle" aria-hidden>
            <VenueIcon />
        </div>
        <div className="name">{venue ?? "—"}</div>
    </div>
))(({ theme }) => ({
    background: brand.white,
    padding: theme.spacing(2.75, 2.5, 2.5),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.75),
    borderBottom: `1px solid ${brand.sep}`,

    "& .circle": {
        width: 54,
        height: 54,
        borderRadius: "50%",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${brand.amber}22 0%, ${brand.amberLight} 100%)`,
        border: `1px solid ${brand.amber}40`,
        color: brand.amberDeep,
    },
    "& .circle .MuiSvgIcon-root": {
        fontSize: 26,
    },
    "& .name": {
        flex: 1,
        minWidth: 0,
        fontSize: 26,
        fontWeight: 700,
        letterSpacing: -0.5,
        color: brand.text,
        lineHeight: 1.1,
    },
}));

export const FactList = styled("div")(({ theme }) => ({
    background: brand.white,
    padding: theme.spacing(0.5, 2.5, 1),
}));

export const FactRow = styled(({ label, value, className }) => (
    <div className={className}>
        <Typography className="label" component="span">
            {label}
        </Typography>
        <Typography className="value" component="span">
            {value ?? "—"}
        </Typography>
    </div>
))(({ theme }) => ({
    display: "flex",
    alignItems: "baseline",
    gap: theme.spacing(1.75),
    padding: theme.spacing(1.25, 0),
    borderBottom: `1px solid ${brand.sep}`,
    "&:last-child": {
        borderBottom: "none",
    },

    "& .label": {
        fontSize: 13,
        color: brand.textSec,
        fontWeight: 500,
        width: 54,
        flexShrink: 0,
    },
    "& .value": {
        fontSize: 15,
        color: brand.text,
        fontWeight: 600,
    },
}));
